<template>
  <div class="questionnaire-container">
    <div class="question-empty" v-if="isEmptyPage">
      <!--      <div class="question-top">-->
      <!--        <img-->
      <!--            class="ai-empty-back"-->
      <!--            :src="require('@/assets/back.png')"-->
      <!--            alt="返回"-->
      <!--            @click="goBack"-->
      <!--        />-->
      <!--        <span> 正在为您准备专属的健康对话</span>-->

      <!--      </div>-->
      <div class="question-bottom">
<!--        <img-->
<!--            class="question-icon"-->
<!--            :src="require('@/assets/questionEmpty.png')"-->
<!--            alt="对话"-->
<!--        />-->
        <div class="question-icon" ref="lottieContainer" ></div>
        <div class="question-title">
          正在根据您的身体状况，准备个性化的问题...
        </div>
        <div class="question-tip">对话准备中</div>
      </div>
    </div>
    <!-- AI聊天弹出框 -->
    <div class="dialog-content" v-else>
      <!-- 头部AI标识 -->
      <div class="ai-header">
        <!--        <img-->
        <!--            class="ai-back"-->
        <!--            :src="require('@/assets/back.png')"-->
        <!--            alt="返回"-->
        <!--            @click="goBack"-->
        <!--        />-->
        <img
            class="ai-avatar"
            :src="require('@/assets/AIUnscramble/图标-AI小助手2.png')"
            alt="AI头像"
        />
        <div class="ai-title-container">
          <div class="ai-title">
            <span class="ai-name">AI营养智配</span>
            <div class="ai-sound">
              <img
                  :src="
                  soundOn
                    ? require('@/assets/AIUnscramble/Volume-notice.png')
                    : require('@/assets/AIUnscramble/关闭声音.png')
                "
                  @click="toggleSound"
                  alt="声音图标"
              />
            </div>
          </div>
          <div class="ai-desc">
            AI建议仅供参考，不做医疗诊断依据，请咨询专业医生。
          </div>
        </div>
      </div>

      <!-- 聊天内容区域 -->
      <div
          class="chat-content"
          style="height: calc(100% - 162px)"
          @touchmove.stop
          @wheel.stop
          ref="chatContent"
      >
        <!-- 历史加载中提示 -->
        <div
            v-if="isLoadingHistory && historyPage === 1"
            class="history-loading"
        >
          <div class="dot-countdown-timer">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <!-- 没有更多历史提示 -->
        <div v-if="!hasMoreHistory && historyPage > 1" class="history-end-tip">
          没有更多历史消息了
        </div>

        <!-- 欢迎消息，始终保留 -->
        <!-- <div class="message-row">
          <div class="ai-message">
            您好，我是您的AI营养智配。现在我们花几分钟，聊聊您的报告，好吗？
          </div>
        </div> -->

        <!-- 添加用户消息和AI回复的动态显示 -->
        <div
            v-for="(message, index) in messages"
            :key="index"
            :class="[
            'message-row',
            message.type === 'user' ? 'message-row-user' : 'message-row-ai',
          ]"
        >
          <div
              :class="[
              message.type === 'user' ? 'user-message' : 'ai-message',
              message.isThinking ? 'thinking-message' : '',
            ]"
          >
            <template v-if="message.isThinking">
              <div class="thinking-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </template>
            <template v-else>
              <div style="white-space: pre-line" v-html="formatMessageContent(message.content)"></div>
              <!-- 问题选项列表 -->
              <div v-if="message.questionOptions && message.questionOptions.length > 0" class="question-options-inline">
                <div 
                  v-for="(option, index) in message.questionOptions" 
                  :key="index"
                  class="option-item-inline"
                  :class="{ selected: message.selectedOptions && message.selectedOptions.includes(index), disabled: message.disabled }"
                  @click="toggleOptionInline(message, index)"
                >
                  {{ option }}
                </div>
                <div v-if="message.showConfirmBtn" 
                     class="confirm-btn-inline" 
                     :class="{ enabled: message.selectedOptions && message.selectedOptions.length > 0 }"
                     @click="confirmSelectionInline(message)">
                  确定
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--      补充方案-->
        <div class="thinking-dots" v-if="!recommendList.length && isScheme">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="message-row" v-if="recommendList.length">
          <div class="ai-message scheme-content">
            <!--          <div class="scheme-content">-->
            <div class="scheme-title">您的专属营养补充方案</div>
            <div class="scheme-text">
              根据您的沟通，本方案主要针对：改善血液循环 · 调理肠胃功能 ·
              提升认知精力
            </div>
            <div class="scheme-goods">
              <div
                  class="scheme-item"
                  v-for="item in recommendList"
                  :key="item.id"
              >
                <img :src="item.url" alt="" class="goods-img"/>
                <div class="goods-content">
                  <div class="goods-title">{{ item.name }}</div>
                  <div class="goods-text">{{ item.description }}</div>
                  <div class="goods-price">
                    ¥<span class="price-blod">{{ item.daily_price }}</span
                  >/天
                  </div>
                </div>
              </div>
              <!--            </div>-->
            </div>
          </div>
        </div>
        <!-- AI思考中的动画 -->
        <div v-if="isThinking" class="message-row">
          <div class="ai-message thinking">
            <div class="thinking-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>


    </div>
    

  </div>
</template>

<script>
// import { postAIChatStream } from "@/net/api";
import {getConversationHistory} from "@/net/api";
import {conversationApi} from "@/net/api";
import ContinuousAudioPlayer from "@/utils/AudioContext.js";
import {wxConfig} from "@/utils/useWechatAuth.js";
import lottie from 'lottie-web'
import radar from '@/assets/lottie/radar.json'
export default {
  name: "AIQuestionnaire",
  data() {
    return {
      showChat: false, // 是否显示ai弹出框
      isHiding: false,
      soundOn: true,
      messages: [],
      // isProcessing: false,
      isComposing: false,
      isMultiLine: false,
      isStreaming: false,
      // 打字机效果相关
      typewriterQueue: [],       // 待显示的token队列
      isTyping: false,           // 是否正在打字
      typewriterTimers: [],      // 存储所有打字机相关的定时器
      typingCompleteTimer: null, // 等待打字完成的定时器
      // 历史记录相关
      historyPage: 1,
      historyPageSize: 10,
      isLoadingHistory: false,
      hasMoreHistory: true,
      historyLoaded: false,
      isThinking: false,
      aiInterpretContent: "", // 文本输出
      aiInterpretSummary: "",
      aiInterpretLoading: true,
      eventSource: null,
      isCollecting: true,
      streamReader: null,
      config: {
        sampleRate: 16000,
        channels: 1,
        volume: 1,
        playbackRate: 1.0,
        fadeDuration: 50,
        filterFrequency: 8000,
        smallChunkThreshold: 5000,
      },
      reportPlayer: null,
      packageNo: this.$route.query.packageNo || this.$store.getters.getPackageNo,
      isTokenFinish: true,
      qa_session_id: null,
      isFinish: false,
      recommendList: [],
      end_block: false,
      scrollTimer: null, // 滚动防抖定时器
      isEmptyPage: true,
      currentBubbleCount: 0, // 当前对话中的AI气泡数量
      isScheme: false,
      anim: null,
      requestCount: 0, // 请求计数器
      isFirstRequestComplete: false, // 第一次请求是否完成
      audioPlaybackComplete: false, // 音频播放是否完成
      pendingQuestionOptions: null, // 流式帧中收到的待挂载问题选项

    };
  },
  watch: {
    "$store.getters.getPackageNo": {
      handler(newVal) {
        this.packageNo = this.$route.query.packageNo || newVal;
      },
      immediate: true, // 可选：是否在初始化时立即执行一次
    },
    "$store.getters.GetOpenInterpret": {
      handler(newVal) {
        if (newVal && this.reportPlayer) {
          if (this.reportPlayer.gainNode) {
            this.reportPlayer.gainNode.gain.value = 0;
          }
        }
      },
      immediate: true, // 可选：是否在初始化时立即执行一次
    },
  },
  computed: {
    // 检查 AI 聊天是否可用
    isAIChatEnabled() {
      return this.$store.getters.isAIChatEnabled;
    },
  },
  async mounted() {
    // 空状态动画
    this.anim = lottie.loadAnimation({
      container: this.$refs.lottieContainer, // 动画容器
      renderer: 'svg', // 渲染方式：'svg'、'canvas'、'html'
      loop: true, // 是否循环
      autoplay: true, // 是否自动播放
      animationData: radar // 动画JSON数据
    })
    this.loadChatHistory();


    const isMiniProgram =
        window.__wxjs_environment === "miniprogram" ||
        /miniprogram/i.test(navigator.userAgent) ||
        window.wx?.miniProgram;

    // 只在微信环境中初始化微信SDK
    if (/micromessenger/i.test(navigator.userAgent)) {
      try {
        // 小程序环境需要延迟初始化
        const initDelay = isMiniProgram ? 1000 : 0;

        setTimeout(async () => {
          await this.initWechatSDK();
        }, initDelay);
      } catch (error) {
        console.error("微信 JSSDK 初始化失败:", error);
        this.$wx = null;
      }
    } else {
      // ("非微信环境，跳过微信SDK初始化");
      this.$wx = null;
    }

    // 如果聊天框已打开，添加滚动监听器
    // if (this.showChat && this.$refs.chatContent) {
    //   this.$refs.chatContent.addEventListener("scroll", this.handleScroll);
    // }
  },
  async beforeDestroy() {
    this.anim.destroy() // 组件销毁时清除动画
    // 清理滚动定时器
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }

    // 清理打字机效果相关资源
    this.clearTypewriterResources();

    // 停止并清理音频播放器
    await this.stopAndCleanupAudio();

    // 如果正在录音，停止录音
    if (
        this.recordingStarted &&
        this.$wx &&
        typeof this.$wx.stopRecord === "function"
    ) {
      this.$wx.stopRecord({
        success: () => console.log("组件销毁时停止录音成功"),
        fail: () => console.log("组件销毁时停止录音失败"),
      });
    }

    // 清理录音相关状态
    this.resetRecordingState();
  },
  methods: {
    async getConversation(answer = "") {
      const formData = new FormData();
      formData.append("serial_number", this.packageNo);
      if (this.qa_session_id) {
        formData.append("qa_session_id", this.qa_session_id);
      }
      if (answer) {
        formData.append("answer", answer);
      }
      const res = await conversationApi(formData);
      if (res) {
        this.qa_session_id = res.qa_session_id;
      }
    },

    // 初始化微信SDK
    async initWechatSDK() {
      try{
        // 执行微信配置
        await wxConfig((wx) => {
          this.$wx = wx;
          this.wxSDKReady = true;
          this.setupWechatCallbacks();
          // 小程序环境需要额外的就绪检查
        });
      } catch (error) {
        console.error("微信SDK初始化失败:", error);
      }

    },

    // 设置微信回调
    setupWechatCallbacks() {
      if (!this.$wx) return;
      // 在微信SDK初始化完成后设置录音结束回调
      if (typeof this.$wx.onVoiceRecordEnd === "function") {
        this.$wx.onVoiceRecordEnd({
          complete: (res) => {
            if (!this.isRecording && !this.recordingStarted) {
              // ("未在录音状态");
              return;
            }
            this.localId = res.localId;
            this.resetRecordingState();
            // ("录音超时，自动停止");
            this.processWechatRecording(res.localId);
          },
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    //  打开ai小助手
    toggleChat() {
      // 检查 AI 聊天是否可用
      //   this.showChat = true;
      // 关闭音频ai解读音频
      this.$store.commit("SetOpenAiChat", {openAiChat: true});
      // 控制打开弹窗
      // document.body.style.overflow = "hidden";
      // document.body.style.position = "fixed";
      // document.body.style.width = "100%";

      this.$nextTick(() => {
        // ("对话框已打开，初始化输入区域");

        if (this.isKeyboardMode && this.$refs.textInput) {
          // ("初始化键盘输入区域");
          this.initInputArea();
        } else {
          // ("初始化语音输入区域");
          const voiceInputArea = this.$el.querySelector(".voice-input-area");
          if (voiceInputArea) {
            // voiceInputArea.style.height = "46px";
            // ("直接设置语音输入区域高度为60px");
          } else {
            console.warn("未找到语音输入区域元素");
          }

          setTimeout(() => {
            this.initVoiceArea();
          }, 100);
        }

        // if (this.$refs.chatContent) {
        //   this.$refs.chatContent.addEventListener("scroll", this.handleScroll);
        //
        //   // 重置分页参数，准备加载最新的聊天记录
        //   this.historyPage = 1;
        //   this.hasMoreHistory = true;
        //   this.historyLoaded = false;
        //
        //   // 初始加载最新一页的聊天记录
        //   this.loadChatHistory()
        //     .then(() => {
        //       this.$nextTick(() => {
        //         this.scrollToBottom();
        //       });
        //     })
        //     .catch((err) => {
        //       console.error("初始加载聊天记录失败:", err);
        //       this.scrollToBottom();
        //     });
        // }
      });
    },
    // 关闭ai小助手
    closeChat() {
      // 停止流式数据收集

      // this.stopInterpretation();

      // 清理音频播放器资源
      // if (this.reportPlayer) {
      //   this.reportPlayer.pause();
      //   // this.reportPlayer = null;
      // }

      // 停止所有进行中的进程
      // this.stopAllProcesses();

      // 重置相关状态
      // this.isProcessing = false;

      // 如果正在录音，停止录音
      if (
          this.recordingStarted &&
          this.$wx &&
          typeof this.$wx.stopRecord === "function"
      ) {
        this.$wx.stopRecord({
          success: () => console.log("关闭聊天时停止录音成功"),
          fail: () => console.log("关闭聊天时停止录音失败"),
        });
      }

      this.resetRecordingState();
      this.isStreaming = false;
      this.showChat = false;
      this.$store.commit("SetOpenAiChat", {openAiChat: false});
      this.isHiding = true;
      setTimeout(() => {
        // this.showChat = false;
        this.isHiding = false;
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";

        // if (this.$refs.chatContent) {
        //   this.$refs.chatContent.removeEventListener(
        //     "scroll",
        //     this.handleScroll
        //   );
        // }
      }, 300);
    },
    // 处理动作按钮点击
    handleActionClick() {
      // 获取最新的输入文本状态
      const hasText = this.inputText && this.inputText.trim().length > 0;

      if (hasText) {
        // 如果有文本，则发送文本
        this.sendTextMessage();
      } else {
        // 如果没有文本，则切换回语音模式
        this.switchToVoiceMode();
        // this.$showToast("请先输入问题");
      }
    },
    /**
     * 发送文本消息
     */
    async sendTextMessage() {
      if (!this.$refs.textInput) return;
      if (!this.isTokenFinish) {
        this.$showToast("回答未完成，稍等一下～");
        return;
      }

      // 完全停止当前播放的音频
      await this.stopAndCleanupAudio();

      // 获取输入文本
      const text = this.$refs.textInput.innerText.trim();

      // 如果文本为空，则不处理
      if (!text) {
        return;
      }

      // 添加用户消息到消息列表
      this.messages.push({
        type: "user",
        content: text,
      });

      // 清空输入框
      this.$refs.textInput.innerHTML = "";
      this.inputText = "";
      this.resetInputArea();

      // 滚动到底部，确保新消息可见
      this.scrollToBottom();

      // 重置气泡计数，因为这是用户发起的新对话
      this.currentBubbleCount = 0;

      // 发送文本消息到服务器
      this.startInterpretation(text);
      // this.fetchAIInterpretData(text);
      // this.sendTextToServer(text);
    },
    async initReportPlayer() {
      // 如果已有播放器，完全停止并清理它
      if (this.reportPlayer) {
        await this.stopAndCleanupAudio();
        // 额外等待确保完全清理
        await new Promise(resolve => setTimeout(resolve, 50));
      }

      this.reportPlayer = new ContinuousAudioPlayer({
        sampleRate: this.config.sampleRate,
        channels: this.config.channels,
        volume: this.config.volume,
        playbackRate: this.config.playbackRate,
        fadeDuration: this.config.fadeDuration,
        filterFrequency: this.config.filterFrequency,
        smallChunkThreshold: this.config.smallChunkThreshold,
        onStatusUpdate: (status) => {
          // 只有在播放完成时才切换到重播图标，不包括初始化时的"已停止"状态
          if (status === "播放完成") {
            // this.soundOn = 0; // 切换到重播图标
          }
        },
        onPlaybackComplete: () => {
          // 播放完成回调
          this.audioPlaybackComplete = true;
          this.checkAndStartSecondRequest();
        },
      });

      // 创建播放器后，确保应用当前的静音状态
      this.$nextTick(() => {
        if (this.reportPlayer && this.reportPlayer.gainNode) {
          this.reportPlayer.gainNode.gain.value = this.soundOn
              ? this.reportPlayer.volume || 1
              : 0;
        }
      });

      return this.reportPlayer;
    },

    base64ToArrayBuffer(base64) {
      const binaryStr = atob(base64);
      const len = binaryStr.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }
      return bytes.buffer;
    },

    decodePcmData(arrayBuffer) {
      try {
        if (!arrayBuffer || arrayBuffer.byteLength === 0) {
          console.warn("收到空的音频数据");
          return null;
        }

        const int16Array = new Int16Array(arrayBuffer);
        const floatArray = new Float32Array(int16Array.length);

        const compressionThreshold = 0.6;
        const compressionRatio = 0.7;

        for (let i = 0; i < int16Array.length; i++) {
          let sample = int16Array[i] / 32768.0;

          if (Math.abs(sample) > compressionThreshold) {
            const excess = Math.abs(sample) - compressionThreshold;
            const compression = excess * (1 - compressionRatio);
            sample =
                sample > 0
                    ? compressionThreshold + compression
                    : -compressionThreshold - compression;
          }

          floatArray[i] = sample * 0.85;
        }

        return floatArray;
      } catch (err) {
        console.error("解码 PCM 数据失败:", err);
        return null;
      }
    },
    // 检查并启动第二次请求
    checkAndStartSecondRequest() {
      // 只有第一次请求完成且音频播放完成时才启动第二次请求
      if (this.isFirstRequestComplete && this.audioPlaybackComplete && this.requestCount === 1) {
        console.log('第一次请求和音频播放都已完成，开始第二次请求');
        this.startInterpretation('');
      }
    },

    handleFirstRequestEnd() {
      if (this.requestCount !== 1 || this.isFirstRequestComplete) {
        return;
      }

      this.isFirstRequestComplete = true;

      this.waitForAudioComplete(() => {
        this.audioPlaybackComplete = true;
        this.checkAndStartSecondRequest();
      });
    },

    // 发送文本消息，获取音频流（带payload）
    async startInterpretationWithPayload(text = "", payload = null) {
      return this.startInterpretation(text, payload);
    },

    // 发送文本消息，获取音频流
    async startInterpretation(text = "", payload = null) {
      // 检查请求次数限制
      if (this.requestCount >= 5) {
        console.log('已达到最大请求次数');
        return;
      }
      
      this.requestCount++;
      console.log(`第${this.requestCount}次请求`);
      
      // 重置状态标志
      if (this.requestCount === 1) {
        this.isFirstRequestComplete = false;
        this.audioPlaybackComplete = false;
      }
      
      // 先停止之前的流数据收集
      if (this.streamReader) {
        await this.streamReader.cancel();
        this.streamReader = null;
      }

      // 完全停止并清理之前的音频播放器
      await this.stopAndCleanupAudio();
      
      // 等待一小段时间确保音频完全停止
      await new Promise(resolve => setTimeout(resolve, 100));
      // const params = {
      //   serial_number:this.packageNo,
      //   qa_session_id:this.qa_session_id,
      //   answer:text,
      // }
      const formData = new FormData();
      formData.append("serial_number", this.packageNo);
      // formData.append("content", text);
      formData.append("answer", text);
      if (this.qa_session_id) {
        formData.append("qa_session_id", this.qa_session_id);
      }
      if (this.$route.query.user_Data) {
        formData.append("user_data", JSON.stringify(this.$route.query.user_Data));
      }
      if (payload) {
        formData.append("payload", JSON.stringify(payload));
      }
      this.aiInterpretContent = "";
      this.aiInterpretSummary = "";
      this.aiInterpretLoading = true;
      this.isCollecting = true;
      this.isTokenFinish = false;
      
      // 清理之前的打字机状态
      this.clearTypewriterResources();
      
      await this.initReportPlayer();
      // 在用户交互的同步上下文中初始化音频
      this.reportPlayer.initAudioContext();

      // 初始化后立即应用当前的静音状态
      if (this.reportPlayer && this.reportPlayer.gainNode) {
        this.reportPlayer.gainNode.gain.value = this.soundOn
            ? this.reportPlayer.volume || 1
            : 0;
      }

      if (this.eventSource) {
        this.eventSource.close();
      }
      // 第一次调用时添加思考中的消息
      if (this.currentBubbleCount === 0) {
        this.messages.push({
          type: "ai",
          content: "",
          isThinking: true,
        });
        this.currentBubbleCount = 1; // 标记已添加第一个气泡
      }

      this.scrollToBottom();
      try {
        // const response = await postAIChatStream(formData);
        const response = await conversationApi(formData);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (!response.body) {
          throw new Error("ReadableStream not supported in this browser.");
        }

        this.aiInterpretLoading = false;

        this.streamReader = response.body.getReader();
        const decoder = new TextDecoder();
        let partialData = "";
        this.isEmptyPage = false;
        let tokenData = '';

        while (this.isCollecting) {
          try {
            const {done, value} = await this.streamReader.read();

            if (done) {
              // ("流数据读取完成");
              break;
            }
            const textData = decoder.decode(value, {stream: true});
            const dataChunks = (partialData + textData).split("\n");
            partialData = dataChunks.pop() || "";

            for (const chunk of dataChunks) {
              if (!chunk.trim()) continue;

              try {
                // 处理 Server-Sent Events 格式的数据
                let jsonString = chunk;

                // 如果是 SSE 格式，提取 data: 后面的内容
                if (chunk.startsWith("data: ")) {
                  jsonString = chunk.substring(6); // 移除 "data: " 前缀
                }

                // 跳过空数据或注释行
                if (!jsonString.trim() || jsonString.startsWith(":")) {
                  continue;
                }
                const jsonData = JSON.parse(jsonString);
                const {
                  token,
                  audio,
                  error,
                  token_finish,
                  state = {},
                  start_block,
                  end_block
                } = jsonData;
                if (end_block) {
                  this.currentBubbleCount++; // 增加气泡计数
                  
                  // 第一次请求结束
                  if (this.requestCount === 1) {
                    this.handleFirstRequestEnd();
                  }
                }
                // 处理 start_block，从第二个气泡开始才根据 start_block 添加新气泡
                if (start_block && this.currentBubbleCount > 1) {
                  this.messages.push({
                    type: "ai",
                    content: "",
                    isThinking: true,
                  });
                }

                // 确保当前消息不是思考状态
                if (this.messages.length > 0) {
                  if (state.is_finished && state.recommend_result_list.length > 0 && this.messages[this.messages.length - 1].isThinking) {
                    this.messages.pop()
                  } else {
                    this.messages[this.messages.length - 1].isThinking = false;
                    // 思考状态结束后，立即开始处理队列中的token
                    if (this.typewriterQueue.length > 0 && !this.isTyping) {
                      this.processTypewriterQueue();
                    }
                  }
                }
                if (state.is_finished) {
                  this.isFinish = true;
                  this.scrollToBottom();
                }
                if (
                    state.recommend_result_list &&
                    state.recommend_result_list.length > 0
                ) {
                  this.recommendList = state.recommend_result_list;
                  this.isScheme = false

                }
                if (token_finish) {
                  this.isTokenFinish = true;
                  // 等待打字机效果完成，并传递完整内容以确保内容完整性
                  this.waitForTypingComplete(tokenData);
                  tokenData = ''

                  if (this.currentBubbleCount > 1) {
                    this.isScheme = true
                  }
                }
                // console.log(jsonData);
                if (state.qa_session_id) {
                  this.qa_session_id = state.qa_session_id;
                }
                this.applyQuestionOptions(state);
                // 注释掉这里的滚动调用，改用 token 处理时的防抖滚动
                // if (!this.isTokenFinish) {
                //   this.scrollToBottom();
                // }
                if (error) {
                  // this.messages[this.messages.length-1].isThinking= false;
                  this.messages[this.messages.length - 1].content =
                      "很抱歉未能回答（网络或问题限制）。建议：\n 1. 稍后重试 ​\n​2. 检查网络​ \n​3. 换种提问方式 \n" +
                      (error.message ? "4. " + error.message : "");
                  return;
                }
                if (token) {
                  tokenData += token
                  // 使用打字机效果逐字显示
                  this.typewriterEffect(token);
                  // 使用防抖滚动，避免频繁调用
                  this.debouncedScrollToBottom();
                }

                if (audio && this.soundOn && this.reportPlayer) {
                  // 确保播放器仍然有效且未被清理
                  if (this.reportPlayer.audioContext && this.reportPlayer.audioContext.state !== "closed") {
                    const arrayBuffer = this.base64ToArrayBuffer(audio);
                    const pcmData = this.decodePcmData(arrayBuffer);

                    if (pcmData) {
                      try {
                        this.reportPlayer.addPCMData(pcmData);
                      } catch (error) {
                        console.warn("添加音频数据失败:", error);
                      }
                    }
                  }
                }
              } catch (e) {
                console.error("解析数据失败:", e, "原始数据:", chunk);
                // 不要在这里设置 isCollecting = false，继续处理其他数据
              }
            }
          } catch (readError) {
            console.error("读取流数据失败:", readError);
            break;
          }
        }

        // 处理剩余的部分数据
        if (partialData.trim()) {
          try {
            let jsonString = partialData;
            if (partialData.startsWith("data: ")) {
              jsonString = partialData.substring(6);
            }

            if (jsonString.trim() && !jsonString.startsWith(":")) {
              const jsonData = JSON.parse(jsonString);
              const {
                token, summarize, audio, state = {}, token_finish, start_block,
                end_block
              } = jsonData;
              if (end_block) {
                this.currentBubbleCount++; // 增加气泡计数
                
                // 第一次请求结束
                if (this.requestCount === 1) {
                  this.handleFirstRequestEnd();
                }
              }
              // 处理 start_block，从第二个气泡开始才根据 start_block 添加新气泡
              if (start_block && this.currentBubbleCount > 1) {
                this.messages.push({
                  type: "ai",
                  content: "",
                  isThinking: true,
                });
              }
              if (token) {
                tokenData += token
                // 处理剩余数据时也使用打字机效果
                this.typewriterEffect(token);
              }
              if (summarize) this.aiInterpretSummary += summarize;
              if (this.messages.length > 0) {
                if (state.is_finished && state.recommend_result_list.length > 0 && this.messages[this.messages.length - 1].isThinking) {
                  this.messages.pop()
                } else {
                  this.messages[this.messages.length - 1].isThinking = false;
                  // 思考状态结束后，立即开始处理队列中的token
                  if (this.typewriterQueue.length > 0 && !this.isTyping) {
                    this.processTypewriterQueue();
                  }
                }
              }
              if (state.is_finished) {
                this.isFinish = true;
              }
              if (
                  state.recommend_result_list &&
                  state.recommend_result_list.length > 0
              ) {
                this.recommendList = state.recommend_result_list;
                console.log(this.recommendList);
                this.isScheme = false

              }
              if (token_finish) {
                this.isTokenFinish = true;
                // 等待打字机效果完成，并传递完整内容以确保内容完整性
                this.waitForTypingComplete(tokenData);
                tokenData = ''
                if (this.currentBubbleCount > 1) {
                  this.isScheme = true
                }
              }
              if (state.qa_session_id) {
                this.qa_session_id = state.qa_session_id;
              }
              this.applyQuestionOptions(state);
              if (audio && this.soundOn && this.reportPlayer) {
                // 确保播放器仍然有效且未被清理
                if (this.reportPlayer.audioContext && this.reportPlayer.audioContext.state !== "closed") {
                  const arrayBuffer = this.base64ToArrayBuffer(audio);
                  const pcmData = this.decodePcmData(arrayBuffer);

                  if (pcmData) {
                    try {
                      this.reportPlayer.addPCMData(pcmData);
                    } catch (error) {
                      console.warn("添加音频数据失败:", error);
                    }
                  }
                }
              }
            }
          } catch (e) {
            console.error("处理剩余数据失败:", e);
          }
        }
        if (!this.showChat && this.reportPlayer) {
          // this.reportPlayer.stop();
          this.reportPlayer = null;
        }
      } catch (error) {
        console.error("启动解读失败:", error);
        this.aiInterpretLoading = false;
      } finally {
        this.isCollecting = false;
      }
    },

    // 停止流数据收集
    stopInterpretation() {
      // this.isCollecting = false;
      if (this.streamReader) {
        this.streamReader.cancel();
        this.streamReader = null;
      }
    },
    // 切换是否静音播放
    toggleSound() {
      this.soundOn = !this.soundOn;

      // 控制音频播放器
      if (this.reportPlayer) {
        if (this.soundOn) {
          // 如果音频播放器有gainNode，恢复音量
          if (this.reportPlayer.gainNode) {
            this.reportPlayer.gainNode.gain.value =
                this.reportPlayer.volume || 1;
          }
        } else {
          // 关闭声音 - 将音量设为0实现静音效果，而不是暂停播放
          if (this.reportPlayer.gainNode) {
            this.reportPlayer.gainNode.gain.value = 0;
          }
        }
      }
    },

    // 检查微信录音功能是否可用
    isWechatRecordAvailable() {
      const isWechat = /micromessenger/i.test(navigator.userAgent);
      const hasWxSDK = this.$wx && typeof this.$wx.startRecord === "function";
      const isMiniProgram =
          window.__wxjs_environment === "miniprogram" ||
          /miniprogram/i.test(navigator.userAgent) ||
          window.wx?.miniProgram;

      // 小程序环境需要额外检查
      if (isMiniProgram && !this.wxSDKReady) {
        // ("小程序环境下微信SDK未就绪");
        return false;
      }

      return isWechat && hasWxSDK && this.wxSDKReady;
    },

    // 重置录音状态
    resetRecordingState() {
      // ("重置录音状态");
      this.isRecording = false;
      this.recordingStarted = false;
      this.isCancelled = false;
      this.canCancel = true;
      this.touchStartTime = 0;

      // 清理倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        this.countdownSeconds = 60;
      }

      // 清理取消延迟计时器
      if (this.cancelDelayTimer) {
        clearTimeout(this.cancelDelayTimer);
        this.cancelDelayTimer = null;
      }
    },

    // 开始录音
    async startRecording(e) {
      // ("startRecording 被调用");
      if (!this.isTokenFinish) {
        // this.$showToast("回答未完成，稍等一下～");
        this.$showToast('回答未完成，稍等一下～');
        return;
      }

      // 在开始录音前停止音频播放
      await this.stopAndCleanupAudio();

      // 安全地阻止事件冒泡
      if (e && typeof e.stopPropagation === "function") {
        e.stopPropagation();
      }
      if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
      }
      const voiceButton = e.currentTarget || e.target.closest('.voice-button');
      if (!voiceButton) {
        console.warn('录音事件来源不正确');
        return;
      }

      // 记录触摸开始位置和时间
      if (e.touches && e.touches[0]) {
        this.touchStartY = e.touches[0].clientY;
      } else if (e.clientY) {
        this.touchStartY = e.clientY;
      }

      this.touchStartTime = Date.now();
      this.canCancel = true;

      // console.log(
      //   `触摸开始位置: ${this.touchStartY}, 开始时间: ${this.touchStartTime}`
      // );

      // 如果已经在录音或正在处理中，则不执行
      if (this.isRecording) {
        // ("已在录音状态，忽略重复请求");
        return;
      }

      // 立即设置录音状态
      this.isRecording = true;
      this.recordingStarted = false; // 重置微信录音开始状态
      // ("录音状态已设置为 true");

      // 设置延迟计时器，1秒后禁用取消功能
      this.cancelDelayTimer = setTimeout(() => {
        this.canCancel = false;
        // ("停滞时间超过1秒，禁用取消功能");
      }, 1000);

      // 检查微信录音功能是否可用
      if (!this.isWechatRecordAvailable()) {
        const isWechat = /micromessenger/i.test(navigator.userAgent);
        const isMiniProgram =
            window.__wxjs_environment === "miniprogram" ||
            /miniprogram/i.test(navigator.userAgent) ||
            window.wx?.miniProgram;

        if (!isWechat) {
          this.$showToast("请在微信中使用语音功能");
        } else if (!this.wxSDKReady) {
          if (isMiniProgram) {
            this.$showToast("小程序环境初始化中，请稍后重试");
            // 在小程序环境下，尝试重新初始化
            setTimeout(() => {
              this.initWechatSDK();
            }, 1000);
          } else {
            this.$showToast("微信功能初始化中，请稍后重试");
          }
        } else if (!this.$wx) {
          this.$showToast("微信SDK初始化失败，请刷新页面重试");
        } else {
          this.$showToast("当前微信版本不支持录音功能");
        }
        this.resetRecordingState();
        return;
      }

      // 使用微信录音
      this.$wx.startRecord({
        success: () => {
          // 只有在用户还在按住时才设置为真正开始
          if (this.isRecording) {
            this.recordingStarted = true;
            this.startCountdown();
            if (this.reportPlayer) {
              if (this.reportPlayer.gainNode) {
                this.reportPlayer.gainNode.gain.value = 0;
              }
            }
          } else {
            // 如果用户已经松手，立即停止录音
            this.$wx.stopRecord({
              success: () => console.log("已停止录音"),
              fail: () => console.log("停止录音失败"),
            });
          }
        },
        cancel: () => {
          this.$showToast("需要录音权限才能使用语音功能");
          this.resetRecordingState();
        },
        fail: () => {
          // 只有在用户还在按住时才显示错误提示
          if (this.isRecording) {
            this.$showToast("录音启动失败，请重试");
          }
          this.resetRecordingState();
        },
      });
    },
    // 结束录音
    stopRecording(e) {
      // 安全地阻止事件冒泡
      if (e && typeof e.stopPropagation === "function") {
        e.stopPropagation();
      }
      if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
      }
      // 确保事件来源是录音按钮区域
      const voiceButton = e.currentTarget || e.target.closest('.voice-button');
      if (!voiceButton) {
        console.warn('停止录音事件来源不正确');
        return;
      }

      // 如果没有在录音，则不处理
      if (!this.isRecording) {
        // "未在录音状态，忽略停止录音请求"
        return;
      }

      // 清理倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        this.countdownSeconds = 60;
      }

      // 先重置录音状态
      this.isRecording = false;

      // 如果是取消状态，重置取消标志并返回
      if (this.isCancelled) {
        //"录音被取消，不进行语音识别");
        this.isCancelled = false;

        // 如果微信录音已经开始，需要停止它
        if (
            this.recordingStarted &&
            this.$wx &&
            typeof this.$wx.stopRecord === "function"
        ) {
          // "取消录音，停止微信录音");
          this.$wx.stopRecord({
            success: () => {
              // "取消录音成功");
              this.resetRecordingState();
            },
            fail: () => {
              // "取消录音失败:", err);
              this.resetRecordingState();
            },
          });
        } else {
          this.resetRecordingState();
        }
        return;
      }

      // 检查是否使用微信录音且录音已真正开始
      if (
          this.recordingStarted &&
          this.$wx &&
          typeof this.$wx.stopRecord === "function"
      ) {
        // 使用微信录音停止
        // "停止微信录音");
        this.$wx.stopRecord({
          success: (res) => {
            this.localId = res.localId;
            // "微信录音结束，localId:", res.localId);
            // 注意：这里不要重置状态，因为还需要处理录音结果
            this.recordingStarted = false;
            // 处理微信录音的结果
            this.processWechatRecording(res.localId);
          },
          fail: () => {
            // "停止微信录音失败:", err);
            this.resetRecordingState();
            this.$showToast("录音停止失败，请重试");
          },
        });
      } else if (!this.recordingStarted) {
        // "微信录音尚未开始，无需停止");
        // 如果录音还没真正开始就松手了，不需要做任何处理
      } else {
        //"微信SDK不可用，无法停止录音");
        this.$showToast("当前环境不支持录音功能");
      }
    },
    startCountdown() {
      // 清除可能存在的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        this.countdownSeconds = 60;
      }

      this.countdownTimer = setInterval(() => {
        this.countdownSeconds -= 1;

        // 当倒计时结束时，自动停止录音并发送
        if (this.countdownSeconds <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          this.countdownSeconds = 60;
          if (this.isRecording) {
            // "计时器停止");
            this.stopRecording();
          }

          // 设置isCancelled为false确保消息会被发送
          this.isCancelled = false;

          // this.stopRecording({
          //   stopPropagation: () => {},
          //   preventDefault: () => {}
          // });
        }
      }, 1000);
    },
    // 处理触摸移动 - 用于取消录音
    handleTouchMove(e) {
      // 安全地阻止事件冒泡
      if (e && typeof e.stopPropagation === "function") {
        e.stopPropagation();
      }
      // 确保事件来源是录音按钮区域
      const voiceButton = e.currentTarget || e.target.closest('.voice-button');
      if (!voiceButton) {
        return;
      }
      // 如果没有在录音，则不处理
      if (!this.isRecording) return;

      // 获取当前触摸位置
      let currentY;
      if (e.touches && e.touches[0]) {
        currentY = e.touches[0].clientY;
      } else if (e.clientY) {
        currentY = e.clientY;
      } else {
        return;
      }

      // 计算移动距离
      const moveDistance = this.touchStartY - currentY;

      // 如果上移超过50px，显示取消提示
      if (moveDistance > 50) {
        if (!this.isCancelled) {
          this.isCancelled = true;
          // ("录音设置为取消状态");
        }
      } else {
        if (this.isCancelled) {
          this.isCancelled = false;
          // ("录音取消状态已重置");
        }
      }
    },
    // 切换选项选择状态（多选）
    toggleOptionInline(message, optionIndex) {
      // 如果是禁用状态，不允许点击
      if (message.disabled) {
        return;
      }
      
      console.log('点击选项:', optionIndex, message);
      if (!message.selectedOptions) {
        this.$set(message, 'selectedOptions', []);
      }
      
      const index = message.selectedOptions.indexOf(optionIndex);
      if (index > -1) {
        // 如果已选择，则取消选择
        message.selectedOptions.splice(index, 1);
        console.log('取消选择:', optionIndex, '当前选择:', message.selectedOptions);
      } else {
        // 如果未选择，则添加选择
        message.selectedOptions.push(optionIndex);
        console.log('添加选择:', optionIndex, '当前选择:', message.selectedOptions);
      }
    },

    // 确认选择并发送答案
    async confirmSelectionInline(message) {
      if (!message.selectedOptions || message.selectedOptions.length === 0) {
        return;
      }
      
      // 获取选中的选项文本
      const selectedTexts = message.selectedOptions.map(index => message.questionOptions[index]);
      const apiAnswer = selectedTexts.join(','); // API传递用英文逗号
      
      // 构建payload对象，记录选中的索引
      const payload = {};
      message.selectedOptions.forEach((optionIndex, i) => {
        payload[i.toString()] = optionIndex;
      });
      
      // 隐藏确定按钮并禁用选项
      message.showConfirmBtn = false;
      message.disabled = true;
      
      // 重置气泡计数并启动下一次请求
      this.currentBubbleCount = 0;
      this.startInterpretationWithPayload(apiAnswer, payload);
    },

    /**
     * 切换到键盘输入模式
     * 功能：从语音模式切换到键盘文本输入模式，并初始化输入框
     */
    switchToKeyboardMode(e) {
      // 阻止事件冒泡和默认行为
      e.stopPropagation();
      e.preventDefault();

      // 如果正在录音，先停止录音
      if (
          this.isRecording &&
          this.recordingStarted &&
          this.$wx &&
          typeof this.$wx.stopRecord === "function"
      ) {
        this.$wx.stopRecord({
          success: () => console.log("切换键盘模式时停止录音成功"),
          fail: () => console.log("切换键盘模式时停止录音失败"),
        });
      }

      // 重置录音状态
      this.resetRecordingState();

      // 切换到键盘输入模式
      this.isKeyboardMode = true;
      // this.isProcessing = false; // 重置处理状态

      // 等待DOM更新后初始化输入框
      this.$nextTick(() => {
        if (this.$refs.textInput) {
          this.initInputArea();
          // 聚焦输入框
          this.$refs.textInput.focus();
        }
      });
    },
    /**
     * 切换到语音模式
     * 功能：从键盘输入模式切换回语音输入模式
     */
    switchToVoiceMode() {
      // 如果正在处理中，则不执行
      // if (this.isProcessing) return;

      // ("切换到语音模式");

      // 重置所有状态
      this.isKeyboardMode = false;
      this.inputText = "";
      this.isMultiLine = false;

      // 重置输入框
      if (this.$refs.textInput) {
        this.$refs.textInput.innerHTML = "";
      }

      // 确保语音输入区域样式正确
      this.$nextTick(() => {
        // 直接设置语音输入区域样式
        const voiceInputArea = this.$el.querySelector(".voice-input-area");
        if (voiceInputArea) {
          // voiceInputArea.style.height = "46px";
          console.log("切换到语音模式：设置高度为60px");
        } else {
          console.warn("切换到语音模式：未找到语音输入区域元素");
        }

        // 再次调用initVoiceArea作为备份
        setTimeout(() => {
          this.initVoiceArea();
        }, 100);
      });
    },

    // 停止并清理音频播放器
    async stopAndCleanupAudio() {
      if (this.reportPlayer) {
        try {
          // 1. 首先停止播放和暂停
          this.reportPlayer.stop();
          this.reportPlayer.pause();
          
          // 2. 强制设置播放状态为完成，阻止新数据添加
          this.reportPlayer.isCompleted = true;
          this.reportPlayer.isPlaying = false;
          this.reportPlayer.isPaused = false;
          
          // 3. 清理缓冲区
          if (this.reportPlayer.clearBuffer) {
            this.reportPlayer.clearBuffer();
          }
          
          // 4. 重置播放状态
          if (this.reportPlayer.reset) {
            this.reportPlayer.reset();
          }
          
          // 5. 安全地断开音频节点连接
          try {
            if (this.reportPlayer.scriptNode) {
              this.reportPlayer.scriptNode.onaudioprocess = null;
              this.reportPlayer.scriptNode.disconnect();
              this.reportPlayer.scriptNode = null;
            }
          } catch (e) {
            console.warn("断开scriptNode失败:", e);
          }
          
          try {
            if (this.reportPlayer.gainNode) {
              this.reportPlayer.gainNode.disconnect();
            }
          } catch (e) {
            console.warn("断开gainNode失败:", e);
          }
          
          try {
            if (this.reportPlayer.filterNode) {
              this.reportPlayer.filterNode.disconnect();
            }
          } catch (e) {
            console.warn("断开filterNode失败:", e);
          }
          
          // 6. 关闭音频上下文
          if (this.reportPlayer.audioContext) {
            try {
              if (this.reportPlayer.audioContext.state === "running") {
                await this.reportPlayer.audioContext.suspend();
              }
              if (this.reportPlayer.audioContext.state !== "closed") {
                await this.reportPlayer.audioContext.close();
              }
            } catch (e) {
              console.warn("关闭音频上下文失败:", e);
            }
          }
          
          // 7. 等待一小段时间确保所有异步操作完成
          await new Promise(resolve => setTimeout(resolve, 50));
          
        } catch (error) {
          console.warn("清理音频播放器时出错:", error);
        } finally {
          this.reportPlayer = null;
        }
      }
    },

    // 处理微信录音结果
    processWechatRecording(localId) {
      // ("开始处理微信录音，localId:", localId);

      if (!localId) {
        console.error("localId 为空，无法进行语音识别");
        this.$showToast("录音数据异常，请重试");
        return;
      }

      // 停止当前播放的音频
      if (this.reportPlayer) {
        this.reportPlayer.stop();
        this.reportPlayer.pause();
      }

      let that = this;
      this.$wx.translateVoice({
        localId: localId, // 需要识别的音频的本地Id，由录音相关接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function (res) {
          // ("语音识别成功:", res);

          // 检查识别结果
          if (res.translateResult && res.translateResult.trim()) {
            // 添加用户语音消息
            that.messages.push({
              type: "user",
              content: res.translateResult,
            });

            // ("识别到的文本:", res.translateResult);
            that.scrollToBottom();

            // 重置气泡计数，因为这是用户发起的新对话
            that.currentBubbleCount = 0;

            that.startInterpretation(res.translateResult);
          } else {
            // ("语音识别结果为空");
            that.$showthis.$showToast("未识别到说话内容，请重试");
          }
        },
        fail: function (err) {
          console.error("语音识别失败:", err);
          that.$showthis.$showToast("语音识别失败，请重试");
        },
      });
    },
    /**
     * 滚动聊天内容到底部
     * 功能：确保最新消息可见
     */
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.chatContent) {
          // 使用 setTimeout 确保所有 DOM 更新完成
          setTimeout(() => {
            this.$refs.chatContent.scrollTop =
                this.$refs.chatContent.scrollHeight;
          }, 10);
        }
      });
    },

    /**
     * 防抖滚动到底部
     * 功能：避免频繁滚动调用
     */
    debouncedScrollToBottom() {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        this.scrollToBottom();
      }, 50);
    },
    /**
     * 处理对话框触摸移动事件
     * 功能：允许聊天内容区域滚动，阻止背景滚动
     * @param {Event} e - 触摸移动事件对象
     */
    handleDialogTouchMove(e) {
      // 如果目标元素是聊天内容区域或其子元素，允许滚动
      if (
          this.$refs.chatContent &&
          (e.target === this.$refs.chatContent ||
              this.$refs.chatContent.contains(e.target))
      ) {
        // 允许聊天内容区域滚动，不阻止默认行为
        e.stopPropagation();
      } else {
        // 阻止对话框背景区域的滚动
        e.preventDefault();
      }
    },
    /**
     * 处理对话框鼠标滚轮事件
     * 功能：允许聊天内容区域滚动，阻止背景滚动
     * @param {Event} e - 鼠标滚轮事件对象
     */
    handleDialogWheel(e) {
      // 如果目标元素是聊天内容区域或其子元素，允许滚动
      if (
          this.$refs.chatContent &&
          (e.target === this.$refs.chatContent ||
              this.$refs.chatContent.contains(e.target))
      ) {
        // 允许聊天内容区域滚动，不阻止默认行为
        e.stopPropagation();
      } else {
        // 阻止对话框背景区域的滚动
        e.preventDefault();
      }
    },
    /**
     * 处理输入框内容变化
     * 功能：更新输入文本状态，调整输入框高度
     */
    handleInput() {
      // 如果是输入法编辑过程中，不进行处理
      if (this.isComposing) {
        // ("输入法编辑中，暂不处理");
        return;
      }

      if (!this.$refs.textInput) return;

      // 获取输入内容
      const newText = this.$refs.textInput.innerText || "";

      // 检查内容是否真的为空（包括处理只有空格、换行符等情况）
      const isEmpty = !newText.trim();

      // 更新状态
      this.inputText = isEmpty ? "" : newText;

      // 如果内容为空，重置输入框
      if (isEmpty) {
        this.$refs.textInput.innerHTML = ""; // 确保DOM内容也为空
        this.resetInputArea();
        return;
      }

      // 直接调整高度，无需防抖
      this.adjustInputHeight();
    },

    /**
     * 处理输入法编辑开始事件
     * 功能：标记正在使用输入法编辑(如中文输入)
     */
    handleCompositionStart() {
      this.isComposing = true;
      // ("输入法编辑开始");
    },
    /**
     * 处理输入法编辑结束事件
     * 功能：标记输入法编辑结束，更新输入内容
     */
    handleCompositionEnd() {
      this.isComposing = false;
      // ("输入法编辑结束");

      // 输入法结束后更新内容和调整高度
      this.handleInput();
    },

    /**
     * 调整输入框高度
     * 功能：根据内容自动调整输入框高度，确保向上扩展
     */
    adjustInputHeight() {
      const textInput = this.$refs.textInput;
      if (!textInput) return;

      // 获取输入内容高度
      const scrollHeight = textInput.scrollHeight;

      // 计算行数（假设单行高度约为40px）
      const lineHeight = 40; // 单行文本的大致高度
      const lines = Math.ceil(scrollHeight / lineHeight);

      // 判断是否为多行
      const isMultiLine = lines > 1;

      // 更新多行状态
      if (isMultiLine !== this.isMultiLine) {
        this.isMultiLine = isMultiLine;
      }

      // 获取输入区域容器
      const textInputArea = textInput.closest(".text-input-area");
      const textInputContainer = textInput.closest(".text-input-container");
      if (!textInputArea || !textInputContainer) return;

      // 计算新高度
      // 如果小于等于4行，直接设置高度为内容高度+padding
      // 如果超过4行，设置为4行的高度，并启用滚动
      const maxLines = 4; // 最多显示4行
      const maxHeight = maxLines * lineHeight + 20; // 4行文本高度 + padding

      let newHeight;
      if (lines <= maxLines) {
        // 小于等于4行，高度自适应
        newHeight = Math.max(46, scrollHeight + 20);
      } else {
        // 超过4行，固定为4行高度
        newHeight = maxHeight;
      }

      // 设置输入区域高度
      textInputArea.style.height = `${newHeight}px`;

      // 调整输入包装器的对齐方式
      const inputWrapper = textInput.closest(".input-wrapper");
      if (inputWrapper) {
        if (isMultiLine) {
          // 多行时，调整为顶部对齐
          inputWrapper.style.alignItems = "flex-start";
          inputWrapper.style.paddingTop = "10px";

          // 如果超过4行，启用滚动
          if (lines > maxLines) {
            inputWrapper.style.overflowY = "auto";
            // 滚动到底部，确保光标可见
            inputWrapper.scrollTop = inputWrapper.scrollHeight;
          } else {
            inputWrapper.style.overflowY = "hidden";
          }
        } else {
          // 单行时，保持垂直居中
          inputWrapper.style.alignItems = "center";
          inputWrapper.style.paddingTop = "0";
          inputWrapper.style.paddingBottom = "0";
          inputWrapper.style.overflowY = "hidden";
        }
      }
    },

    /**
     * 重置输入区域
     * 功能：当输入为空时，重置输入框状态和样式
     */
    resetInputArea() {
      if (!this.$refs.textInput) return;

      const textInput = this.$refs.textInput;
      const inputWrapper = textInput.closest(".input-wrapper");

      // 重置状态
      this.isMultiLine = false;

      // 重置DOM
      textInput.innerHTML = "";

      // 重置包装器样式
      if (inputWrapper) {
        inputWrapper.style.alignItems = "center"; // 垂直居中
        inputWrapper.style.paddingTop = "0";
        inputWrapper.style.paddingBottom = "0";
        inputWrapper.style.overflowY = "hidden";
        inputWrapper.scrollTop = 0;
      }
    },

    /**
     * 处理文本输入区域点击事件
     * 功能：确保点击输入区域时聚焦到输入框
     * @param {Event} e - 点击事件对象
     */
    handleTextAreaClick(e) {
      // 如果点击的不是输入框本身，则手动聚焦
      if (e.target !== this.$refs.textInput && this.$refs.textInput) {
        this.$refs.textInput.focus();
      }
    },

    /**
     * 处理输入框失焦事件
     * 功能：在输入框失焦时更新状态，确保占位符正确显示
     */
    handleInputBlur() {
      this.inputFocused = false;

      // 如果输入框内容为空，确保显示占位符并更新状态
      if (this.$refs.textInput) {
        const content = this.$refs.textInput.innerText || "";

        if (!content.trim()) {
          // 更新状态
          this.inputText = "";
          this.$refs.textInput.innerHTML = ""; // 确保DOM内容也为空

          // 重置输入框
          this.resetInputArea();
        }
      }
    },

    /**
     * 处理键盘按键事件
     * 功能：监听Enter键发送消息，调整输入框高度
     * @param {Event} e - 键盘事件对象
     */
    handleKeyDown(e) {
      // 如果正在输入法编辑中，则不处理回车键
      if (e.key === "Enter" && !e.shiftKey && !this.isComposing) {
        e.preventDefault(); // 阻止默认的换行行为
        this.sendTextMessage();
      }

      // 处理退格键删除所有内容的情况
      if (e.key === "Backspace" && this.$refs.textInput) {
        // 使用setTimeout确保在DOM更新后检查内容
        setTimeout(() => {
          const content = this.$refs.textInput.innerText || "";
          if (!content.trim()) {
            // 如果内容为空，立即更新状态
            this.inputText = "";
            this.$refs.textInput.innerHTML = ""; // 确保DOM内容也为空
          }
        }, 0);
      }
    },

    /**
     * 初始化输入区域
     * 功能：设置输入区域的初始状态和高度
     */
    initInputArea() {
      if (!this.$refs.textInput) return;

      const textInput = this.$refs.textInput;
      // const textInputArea = textInput.closest(".text-input-area");
      // const inputWrapper = textInput.closest(".input-wrapper");

      // 重置状态
      this.isMultiLine = false;
      this.inputText = "";

      // 重置DOM
      textInput.innerHTML = "";

      // 重置容器样式
      // if (textInputArea) {
      // 明确设置高度为60px
      // textInputArea.style.height = "46px";
      // }

      // 重置包装器样式
      // if (inputWrapper) {
      //   inputWrapper.style.alignItems = "center";
      //   inputWrapper.style.paddingTop = "0";
      //   inputWrapper.style.paddingBottom = "0";
      //   inputWrapper.style.overflowY = "hidden"; // 重置为隐藏滚动
      //   // 确保滚动位置重置
      //   inputWrapper.scrollTop = 0;
      // }
    },

    /**
     * 初始化语音输入区域
     * 功能：确保语音输入区域的样式正确
     */
    initVoiceArea() {
      this.$nextTick(() => {
        // 使用this.$el查找组件内部的元素，而不是全局document
        const inputArea = this.$el.querySelector(".voice-input-area");
        if (inputArea) {
          // 确保高度正确
          // inputArea.style.height = "60px";
          // ("语音输入区域高度已设置为60px");
        } else {
          console.warn("未找到语音输入区域元素");
        }
      });
    },

    /**
     * 处理聊天区域滚动事件
     * 功能：监听滚动，当用户滚动到顶部时加载更多历史记录
     */
    // handleScroll() {
    //   if (this.isLoadingHistory || !this.hasMoreHistory) return;
    //   if (this.inputFocused) {
    //     this.$refs.textInput.blur();
    //     this.inputFocused = false;
    //   }
    //
    //   const scrollTop = this.$refs.chatContent.scrollTop;
    //
    //   // 当滚动到顶部附近时，加载更多历史
    //   if (scrollTop < 50) {
    //     // ("滚动到顶部，加载更早的历史记录");
    //
    //     // 显示加载提示
    //     const loadingTipElement = document.createElement("div");
    //     loadingTipElement.className = "history-loading-tip";
    //     loadingTipElement.innerHTML = "加载更多...";
    //     loadingTipElement.style.textAlign = "center";
    //     loadingTipElement.style.padding = "10px 0";
    //     loadingTipElement.style.fontSize = "14px";
    //     loadingTipElement.style.color = "#999";
    //
    //     if (this.$refs.chatContent) {
    //       this.$refs.chatContent.insertBefore(
    //         loadingTipElement,
    //         this.$refs.chatContent.firstChild
    //       );
    //     }
    //
    //     // 记录当前滚动高度，用于加载后保持位置
    //     const oldScrollHeight = this.$refs.chatContent.scrollHeight;
    //
    //     // 修改参数，加载更早的记录（顺序为升序）
    //     const params = {
    //       page: this.historyPage,
    //       page_size: this.historyPageSize,
    //       serial_number: this.packageNo,
    //       sort: "asc", // 按时间升序，获取更早的消息
    //     };
    //
    //     // ("加载更早历史记录参数:", JSON.stringify(params));
    //
    //     // 调用API获取历史记录
    //     getConversationHistory(params)
    //       .then((response) => {
    //         // ("获取更早历史记录成功:", response);
    //
    //         // 移除加载提示
    //         const loadingElement = document.querySelector(
    //           ".history-loading-tip"
    //         );
    //         if (loadingElement && loadingElement.parentNode) {
    //           loadingElement.parentNode.removeChild(loadingElement);
    //         }
    //
    //         // 处理返回的数据
    //         const records =
    //           response?.list || response?.items || response?.records || [];
    //
    //         if (records.length > 0) {
    //           // 转换为消息格式
    //           const historyMessages = records.map((item) => {
    //             const messageType = item.chat_type === 2 ? "user" : "ai";
    //             return {
    //               type: messageType,
    //               content: item.content || item.message || "",
    //             };
    //           });
    //
    //           // 在消息列表前面添加历史记录（不包括欢迎消息）
    //           if (historyMessages.length > 0) {
    //             this.messages.splice(1, 0, ...historyMessages);
    //           }
    //
    //           // 增加页码，继续加载下一页
    //           this.historyPage += 1;
    //
    //           // 判断是否还有更多历史记录
    //           const hasNext =
    //             response.hasNext !== undefined
    //               ? response.hasNext
    //               : response.has_more !== undefined
    //               ? response.has_more
    //               : records.length >= this.historyPageSize;
    //
    //           this.hasMoreHistory = hasNext;
    //         } else {
    //           // 没有更多数据了
    //           this.hasMoreHistory = false;
    //           // ("没有更多历史记录");
    //         }
    //
    //         // 加载完成后恢复滚动位置
    //         this.$nextTick(() => {
    //           if (this.$refs.chatContent) {
    //             const newScrollHeight = this.$refs.chatContent.scrollHeight;
    //             const heightDiff = newScrollHeight - oldScrollHeight;
    //             this.$refs.chatContent.scrollTop =
    //               heightDiff > 0 ? heightDiff : 0;
    //           }
    //         });
    //       })
    //       .catch((err) => {
    //         console.error("加载历史记录失败:", err);
    //
    //         // 移除加载提示
    //         const loadingElement = document.querySelector(
    //           ".history-loading-tip"
    //         );
    //         if (loadingElement && loadingElement.parentNode) {
    //           loadingElement.parentNode.removeChild(loadingElement);
    //         }
    //
    //         this.hasMoreHistory = false;
    //       })
    //       .finally(() => {
    //         this.isLoadingHistory = false;
    //       });
    //
    //     // 设置加载状态
    //     this.isLoadingHistory = true;
    //   }
    // },

    /**
     * 加载聊天历史记录
     * 功能：从服务器获取历史聊天记录并添加到消息列表
     */
    async loadChatHistory() {
      try {
        // 构建请求参数
        const params = {
          serial_number: this.packageNo,
        };

        // 调用API获取历史记录
        const response = await getConversationHistory(params);
        console.log("获取历史记录响应:", response);

        // 情况1：没有历史记录，直接调用提问接口
        if (!response || response.length === 0) {
          console.log("没有历史记录，开始新的对话");
          this.currentBubbleCount = 0; // 重置气泡计数
          await this.startInterpretation();
          return;
        }

        // 获取第一条记录（最新的记录）
        const firstRecord = response[0];

        // 情况2：第一条消息未完成 (is_finished为false)
        if (!firstRecord.is_finished) {
          console.log("对话未完成，显示历史记录");
          this.isEmptyPage = false;
          // 将历史记录转换为消息格式并显示
          const processedMessages = [];
          
          // 收集问题和对应的payload
          const questionPayloadMap = new Map();
          
          for (let i = 0; i < response.length; i++) {
            const item = response[i];
            
            // 对于AI消息，检查是否有问题选项
            if (item.chat_type === 1 && item.metadata?.state?.flow_type === "qa_content") {
              const questionOptions = item.metadata?.state?.current_question_options;
              if (questionOptions && questionOptions.length > 0) {
                // 查找下一个用户回复的payload
                for (let j = i - 1; j >= 0; j--) {
                  if (response[j].chat_type === 2) {
                    questionPayloadMap.set(i, response[j].metadata?.payload || null);
                    break;
                  }
                }
              }
            }
          }
          
          for (let i = 0; i < response.length; i++) {
            const item = response[i];
            
            // 跳过chat_type=2的用户消息
            if (item.chat_type === 2) {
              continue;
            }
            
            const message = {
              type: "ai",
              content: item.content,
            };
            
            // 检查是否需要显示问题选项
            if (item.metadata?.state?.flow_type === "qa_content") {
              const questionOptions = item.metadata?.state?.current_question_options;
              if (questionOptions && questionOptions.length > 0) {
                this.addQuestionOptions(message, questionOptions, questionPayloadMap.get(i));
              }
            }
            
            processedMessages.push(message);
          }
          
          this.messages = processedMessages.reverse();
          this.scrollToBottom();

          // 如果第一条数据是AI回复(chat_type为1)，需要继续提问
          if (firstRecord.chat_type === 2) {
            console.log("AI已回复，继续对话");
            this.currentBubbleCount = 0; // 重置气泡计数
            await this.startInterpretation();
          }
          // 如果第一条是用户消息(chat_type为2)，等待用户继续输入

          return;
        }

        // 情况3：对话已完成 (is_finished为true)
        if (firstRecord.is_finished) {
          console.log("对话已完成，处理推荐结果");
          this.isEmptyPage = false;
          // 存储推荐列表
          if (firstRecord.result_list && firstRecord.result_list.length > 0) {
            this.recommendList = firstRecord.result_list;
            console.log("存储推荐列表:", this.recommendList);
          }

          // 设置完成状态
          this.isFinish = true;

          // 创建处理后的数组（移除第一条数据）
          const processedResponse = response.slice(1);

          // 将剩余历史记录转换为消息格式
          const processedMessages = [];
          
          // 收集问题和对应的payload
          const questionPayloadMap = new Map();
          
          for (let i = 0; i < processedResponse.length; i++) {
            const item = processedResponse[i];
            
            // 对于AI消息，检查是否有问题选项
            if (item.chat_type === 1 && item.metadata?.state?.flow_type === "qa_content") {
              const questionOptions = item.metadata?.state?.current_question_options;
              if (questionOptions && questionOptions.length > 0) {
                // 查找下一个用户回复的payload
                for (let j = i - 1; j >= 0; j--) {
                  if (processedResponse[j].chat_type === 2) {
                    questionPayloadMap.set(i, processedResponse[j].metadata?.payload || null);
                    break;
                  }
                }
              }
            }
          }
          
          for (let i = 0; i < processedResponse.length; i++) {
            const item = processedResponse[i];
            
            // 跳过chat_type=2的用户消息
            if (item.chat_type === 2) {
              continue;
            }
            
            const message = {
              type: "ai",
              content: item.content,
            };
            
            // 检查是否需要显示问题选项
            if (item.metadata?.state?.flow_type === "qa_content") {
              const questionOptions = item.metadata?.state?.current_question_options;
              if (questionOptions && questionOptions.length > 0) {
                this.addQuestionOptions(message, questionOptions, questionPayloadMap.get(i));
              }
            }
            
            processedMessages.push(message);
          }
          
          this.messages = processedMessages.reverse();
          this.scrollToBottom();
        }
      } catch (error) {
        console.error("获取历史记录出错:", error);
        this.hasMoreHistory = false;
        // 出错时也尝试开始新对话
        try {
          await this.startInterpretation();
        } catch (startError) {
          console.error("启动新对话也失败:", startError);
        }
      } finally {
        this.isLoadingHistory = false;
      }
    },

    // ==================== 打字机效果相关方法 ====================
    
    // 打字机效果核心方法 - 立即开始渲染
    typewriterEffect(newToken) {
      const lastMessage = this.messages[this.messages.length - 1];
      
      // 确保消息存在且不是思考状态
      if (!lastMessage || lastMessage.isThinking) {
        // 如果消息还在思考状态，将token添加到队列等待
        this.typewriterQueue.push(newToken);
        return;
      }

      // 如果当前没有在打字，立即开始处理这个token
      if (!this.isTyping) {
        this.startTypingToken(newToken);
      } else {
        // 如果正在打字，将token添加到队列
        this.typewriterQueue.push(newToken);
      }
    },

    // 开始打字显示一个token
    startTypingToken(token) {
      this.isTyping = true;
      const lastMessage = this.messages[this.messages.length - 1];
      
      // 确保消息内容存在
      if (!lastMessage.content) {
        lastMessage.content = '';
      }

      let charIndex = 0;
      const typeInterval = setInterval(() => {
        if (charIndex < token.length) {
          lastMessage.content += token[charIndex];
          charIndex++;
          this.scrollToBottom();
        } else {
          clearInterval(typeInterval);
          // 从定时器数组中移除已完成的定时器
          const index = this.typewriterTimers.indexOf(typeInterval);
          if (index > -1) {
            this.typewriterTimers.splice(index, 1);
          }
          
          // 当前token显示完成，继续处理队列中的下一个token
          this.processNextToken();
        }
      }, 20); // 每20ms显示一个字符
      
      // 将定时器添加到跟踪数组
      this.typewriterTimers.push(typeInterval);
    },

    // 处理队列中的下一个token
    processNextToken() {
      if (this.typewriterQueue.length > 0) {
        const nextToken = this.typewriterQueue.shift();
        // 立即开始处理下一个token，不延迟
        this.startTypingToken(nextToken);
      } else {
        this.isTyping = false;
      }
    },

    processTypewriterQueue() {
      // 这个方法现在主要用于处理思考状态结束后的队列
      if (this.typewriterQueue.length === 0) {
        this.isTyping = false;
        return;
      }

      const lastMessage = this.messages[this.messages.length - 1];
      
      // 确保消息存在且不是思考状态
      if (!lastMessage || lastMessage.isThinking) {
        // 如果消息不存在或还在思考状态，稍后重试
        const skipTimer = setTimeout(() => {
          this.processTypewriterQueue();
        }, 50);
        this.typewriterTimers.push(skipTimer);
        return;
      }

      // 开始处理队列中的第一个token
      if (!this.isTyping && this.typewriterQueue.length > 0) {
        const token = this.typewriterQueue.shift();
        this.startTypingToken(token);
      }
    },

    // 等待打字机效果完成
    waitForTypingComplete(finalContent = '') {
      // 清理之前的等待定时器
      if (this.typingCompleteTimer) {
        clearInterval(this.typingCompleteTimer);
        this.typingCompleteTimer = null;
      }
      
      this.typingCompleteTimer = setInterval(() => {
        if (!this.isTyping && this.typewriterQueue.length === 0) {
          clearInterval(this.typingCompleteTimer);
          this.typingCompleteTimer = null;
          
          // 标记为完成状态，并确保内容完整性
          const lastMessage = this.messages[this.messages.length - 1];
          if (lastMessage) {
            lastMessage.isCompleted = true;
            // 如果提供了最终内容，确保显示的内容是完整的
            if (finalContent && lastMessage.content !== finalContent) {
              lastMessage.content = finalContent;
            }
          }
          // 保持原始内容，不进行格式化，这样间隔和逐字渲染时一致
        }
      }, 100);
    },

    // 清理打字机效果相关资源
    clearTypewriterResources() {
      // 清理所有打字机相关的定时器
      this.typewriterTimers.forEach(timer => {
        if (timer) {
          clearInterval(timer);
          clearTimeout(timer);
        }
      });
      this.typewriterTimers = [];
      
      // 清理等待打字完成的定时器
      if (this.typingCompleteTimer) {
        clearInterval(this.typingCompleteTimer);
        this.typingCompleteTimer = null;
      }
      
      // 重置打字机状态
      this.isTyping = false;
      this.typewriterQueue = [];
    },
    

    
    // 格式化消息内容
    formatMessageContent(content) {
      if (!content) return '';
      
      // 最后一次推荐请求时不进行格式化处理
      if (this.requestCount === 5) {
        return content;
      }
      
      // 只在真正的列表项前添加换行，避免在句子中间换行
      let formatted = content.replace(/(^|\n|\u3002\s*)(\d+\. )/g, '$1<br/>$2');
      
      // 只在真正的列表项前添加换行
      formatted = formatted.replace(/(^|\n|\u3002\s*)(\d+）)/g, '$1<br/>$2');
      
      // 移除开头可能多余的换行
      formatted = formatted.replace(/^<br\/>/, '');
      
      return formatted;
    },

    // 等待音频播放完成
    waitForAudioComplete(callback) {
      if (!this.reportPlayer || !this.soundOn) {
        setTimeout(callback, 500);
        return;
      }

      const player = this.reportPlayer;
      const bufferLength = player.continuousBuffer?.length || player.fullAudioBuffer?.length || 0;
      const playbackPosition = player.playbackPosition || 0;
      const remainingSamples = Math.max(0, bufferLength - playbackPosition);
      const sampleRate = player.sampleRate || this.config.sampleRate || 16000;
      const playbackRate = player.playbackRate || 1;
      const estimatedRemainingMs = bufferLength > 0
          ? Math.ceil((remainingSamples / sampleRate / playbackRate) * 1000) + 800
          : 500;

      if (bufferLength > 0) {
        setTimeout(callback, Math.max(800, estimatedRemainingMs));
        return;
      }
      
      const checkAudioStatus = () => {
        if (this.reportPlayer && this.reportPlayer.isPlaying) {
          setTimeout(checkAudioStatus, 500);
        } else {
          setTimeout(callback, 500);
        }
      };
      
      checkAudioStatus();
    },

    // 将接口返回的问题选项挂到最近的 AI 气泡，避免流式完成和打字机时序导致选项丢失
    applyQuestionOptions(state) {
      if (
          !state ||
          !state.question_options ||
          state.question_options.length === 0 ||
          state.flow_type !== "qa_content" ||
          this.requestCount >= 5
      ) {
        return;
      }

      this.pendingQuestionOptions = state.question_options;

      const attachOptions = () => {
        for (let i = this.messages.length - 1; i >= 0; i--) {
          const message = this.messages[i];
          if (message && message.type === 'ai' && !message.isThinking) {
            if (!message.questionOptions || message.questionOptions.length === 0) {
              this.addQuestionOptions(message, this.pendingQuestionOptions);
            }
            this.pendingQuestionOptions = null;
            this.scrollToBottom();
            return;
          }
        }
      };

      this.$nextTick(() => {
        attachOptions();
        setTimeout(attachOptions, 500);
      });
    },

    // 统一的问题选项添加方法
    addQuestionOptions(message, questionOptions, payload = null) {
      this.$set(message, 'questionOptions', questionOptions);
      this.$set(message, 'selectedOptions', []);
      this.$set(message, 'showConfirmBtn', false);
      
      if (payload) {
        this.$set(message, 'selectedOptions', Object.values(payload).map(v => parseInt(v)));
        this.$set(message, 'disabled', true);
      } else {
        this.$set(message, 'showConfirmBtn', true);
        this.$set(message, 'disabled', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnaire-container {
  width: 100%;
  height: 100%;
}

.question-empty {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;

  .question-top {
    padding: 36px 20px 26px;
    position: relative;

    span {
      text-align: center;
      display: block;
      color: #00133d;
      font-size: 34px;
      font-weight: bold;
    }

    .ai-empty-back {
      width: 46px;
      height: 46px;
      position: absolute;
      top: 36px;
      left: 30px;
    }
  }

  .question-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 120px);

    .question-icon {
      width: 300px;
      height: 300px;
      margin-bottom: 100px;
    }

    .question-title {
      font-size: 30px;
      margin-bottom: 30px;
    }

    .question-tip {
      color: #999999;
      font-size: 24px;
      margin-bottom: 200px;
    }
  }
}

.dialog-content {
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: auto;
  z-index: 999;
}

.ai-back {
  width: 46px;
  height: 46px;
}

.ai-header {
  background: white;
  padding: 36px 20px 26px;
  //height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: none;

  .ai-avatar {
    width: 80px;
    height: 80px;
    margin: 0 20px 0 30px;
  }

  .ai-title-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 52px;
  }

  .ai-title {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    .ai-name {
      font-size: 40px;
      font-weight: bold;
      color: #000;
      margin-right: 6px;
      line-height: 1.2;
    }

    .ai-sound {
      width: 40px;
      height: 40px;
      margin-left: 18px;
      // cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
    }
  }

  .ai-desc {
    font-size: 20px;
    color: #999;
    text-align: left;
    line-height: 1.2;
  }
}

.chat-content {
  height: calc(100% - 320px);
  //flex: 1;
  padding: 15px 40px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 提供iOS流畅滚动 */
  background: white;

  /* 历史加载状态 */
  .history-loading {
    text-align: center;
    padding: 10px 0;
    margin-bottom: 10px;

    .dot-countdown-timer {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin: 0 3px;
        background: #ccc;
        border-radius: 50%;
        animation: dotLoading 1.4s infinite ease-in-out both;

        &:nth-child(1) {
          animation-delay: -0.32s;
        }

        &:nth-child(2) {
          animation-delay: -0.16s;
        }
      }
    }
  }

  .history-end-tip {
    text-align: center;
    color: #999;
    font-size: 24px;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  .history-loading-tip {
    text-align: center;
    color: #999;
    font-size: 12px;
    padding: 10px 0;
  }

  .message-row {
    display: flex;
    margin-bottom: 15px;
    width: 100%;
  }

  .message-row-user {
    justify-content: flex-end;
  }

  .message-row-ai {
    justify-content: flex-start;
  }

  .ai-message {
    background: #eef2ff;
    border-radius: 18px;
    padding: 18px;
    font-size: 26px;
    color: #000;
    line-height: 1.6;
    display: inline-block;
    word-break: break-word;
    //max-width: 80%;
    text-align: left;

    br {
      content: "";
      display: block;
      margin-top: 10px;
    }

    // 支持段落间距（虽然现在使用pre-line样式）
    p {
      margin: 0 0 8px 0;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .user-message {
    background: #1375fb;
    color: white;
    border-radius: 18px;
    padding: 18px;
    font-size: 26px;
    line-height: 1.6;
    display: inline-block;
    word-break: break-word;
    //max-width: 80%;
    text-align: left;
  }
}

//.chat-content:after {
//  content: "";
//  height: 200px;
//
//  width: 100%;
//  display: block;
//}

.chat-footer {
  //height: auto;
  //min-height: 130px;
  padding: 0 25px;
  height: 200px;
  //line-height: 200px;
  border-top: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  //position: relative;
  //background: pink;
  box-sizing: border-box;
  position: fixed;
  padding-bottom: 40px;
  bottom: 0;
  width: 100%;

  .recording-status {
    text-align: center;
    color: #666;
    font-size: 24px;
    margin-bottom: 40px;
    height: 24px;

    span {
      color: #666;

      &.cancel {
        color: #666;
      }
    }
  }
}

.voice-input-area {
  flex: 1;
  background: white;
  border: 1px solid #e5e9f2;
  border-radius: 30px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  height: 80px !important; /* 强制固定高度 */
  max-height: 80px !important; /* 确保最大高度 */
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &.recording {
    background: #1375fb;
    height: 80px !important; /* 强制固定高度 */
    max-height: 80px !important; /* 确保最大高度 */
    border-radius: 30px;
    border-color: #1375fb;
    box-shadow: none;

    .keyboard-toggle {
      display: none;
    }

    .voice-button span {
      color: white;
    }
  }

  .voice-button {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-touch-callout: none;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation; /* 优化触摸响应 */
    position: relative;
    z-index: 1;
    /* 确保所有子元素都不会阻止事件传递 */
    * {
      pointer-events: none;
    }

    .voice-content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      pointer-events: none;

      .voice-text {
        font-size: 30px;
        color: #333;
        font-weight: normal;
        text-align: center;
        pointer-events: none;
      }
    }

    span {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      pointer-events: none;

      .voice-icon {
        width: 50px;
        height: 50px;
        margin-bottom: 5px;
        pointer-events: none;
      }

      //.voice-text {
      //  font-size: 22px;
      //  color: #333;
      //  font-weight: normal;
      //  text-align: center;
      //}
    }

    .recording-indicator {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 260px;
      width: 100%;
      pointer-events: none;

      * {
        pointer-events: none;
      }

      // .countdown-timer {
      //   color: white;
      //   font-size: 24px;
      //   font-weight: normal;
      //   text-align: center;
      // }
    }
  }
}

.keyboard-toggle {
  width: 46px;
  height: 46px;
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  cursor: pointer;
  background-color: transparent;
  border-radius: 50%;
  top: 0;
  bottom: 0;
  margin: auto;
  transform: none;

  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 50px;
    height: 50px;
    opacity: 0.8;
    transition: opacity 0.2s;
    pointer-events: none;
  }
}

.text-input-container {
  height: auto;
  min-height: 90px;
  // padding: 20px 25px;
  position: relative;
  background: white;
  display: flex;
  align-items: flex-end; /* 将内容底部对齐 */
}

.text-input-area {
  position: relative;
  height: 90px;
  min-height: 90px;
  max-height: 180px; /* 约等于4行文本的高度 */
  border: 1px solid #e5e9f2;
  border-radius: 30px;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  padding: 0;
  overflow: visible;
  transition: height 0.15s ease;
  width: 100%; /* 确保宽度100% */
  margin-bottom: 0; /* 确保底部没有边距 */
}

.input-wrapper {
  flex: 1;
  padding: 0 20px;
  padding-right: 70px;
  height: 100%;
  display: flex;
  align-items: center; /* 保持垂直居中 */
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  -webkit-overflow-scrolling: touch;

  /* 隐藏滚动条但保留滚动功能 */
  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
}

.auto-grow-input {
  width: 100%;
  min-height: 40px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 26px;
  color: #333;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
  caret-color: #1375fb;
  display: flex;
  align-items: center;

  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;

  &:empty:before {
    content: attr(placeholder);
    color: #999;
    position: absolute;
    pointer-events: none;
    font-weight: 400;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  &:focus {
    outline: none;
  }
}

.input-action {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  border-radius: 50%;
  background-color: transparent;

  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 50px;
    height: 50px;
    opacity: 0.8;
    transition: opacity 0.2s;
    pointer-events: none;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes scaleIn {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes scaleOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}

@keyframes dotLoading {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* 思考动画样式 */
.ai-message.thinking-message {
  padding: 18px;
  min-width: 80px;
}

.thinking-dots {
  display: flex;
  justify-content: center;
  align-items: center;
}

.thinking-dots span {
  display: inline-block;
  width: 12px; /* 增大点的尺寸 */
  height: 12px;
  margin: 0 5px;
  background-color: #4285f4; /* 使用更明显的颜色 */
  border-radius: 50%;
  animation: thinking 1.4s infinite ease-in-out both;
  box-shadow: 0 0 5px rgba(66, 133, 244, 0.5); /* 添加发光效果 */
}

.ai-message.thinking-message {
  background-color: #f0f4fe; /* 思考消息的背景色 */
  border: 1px dashed #d0d9ff; /* 添加虚线边框 */
}

@keyframes thinking {
  0%,
  100% {
    transform: scale(0.4);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}

.countdown-timer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.countdown-timer .span {
  background: #fff;
  width: 7px;
  height: 10%;
  border-radius: 14px;
  margin-right: 5px;
}

.countdown-timer .span:last-child {
  margin-right: 0;
}

.countdown-timer .span:nth-child(1) {
  animation: load 2.5s 1.4s infinite linear;
}

.countdown-timer .span:nth-child(2) {
  animation: load 2.5s 1.2s infinite linear;
}

.countdown-timer .span:nth-child(3) {
  animation: load 2.5s 1s infinite linear;
}

.countdown-timer .span:nth-child(4) {
  animation: load 2.5s 0.8s infinite linear;
}

.countdown-timer .span:nth-child(5) {
  animation: load 2.5s 0.6s infinite linear;
}

.countdown-timer .span:nth-child(6) {
  animation: load 2.5s 0.4s infinite linear;
}

.countdown-timer .span:nth-child(7) {
  animation: load 2.5s 0.2s infinite linear;
}

.countdown-timer .span:nth-child(8) {
  animation: load 2.5s 0s infinite linear;
}

.countdown-timer .span:nth-child(9) {
  animation: load 2.5s 0.2s infinite linear;
}

.countdown-timer .span:nth-child(10) {
  animation: load 2.5s 0.4s infinite linear;
}

.countdown-timer .span:nth-child(11) {
  animation: load 2.5s 0.6s infinite linear;
}

.countdown-timer .span:nth-child(12) {
  animation: load 2.5s 0.8s infinite linear;
}

.countdown-timer .span:nth-child(13) {
  animation: load 2.5s 1s infinite linear;
}

.countdown-timer .span:nth-child(14) {
  animation: load 2.5s 1.2s infinite linear;
}

.countdown-timer .span:nth-child(15) {
  animation: load 2.5s 1.4s infinite linear;
}

@keyframes load {
  0% {
    background: #fff;
    margin-top: 0;
    height: 10%;
  }
  50% {
    background: #fff;
    height: 20%;
    margin-top: 0;
  }
  100% {
    background: #fff;
    height: 10%;
    margin-top: 0;
  }
}

.seconds-font {
  font-size: 24px;
}

.scheme-title {
  font-size: 30px;
  color: #003cbf;
}

.scheme-text {
  color: #526584;
  font-size: 24px;
}

.scheme-content {
  width: 100%;
  box-sizing: border-box;
}

.scheme-goods {
  width: 100%;

  .scheme-item {
    display: flex;
    background-color: #fff;
    border-radius: 20px;
    padding: 20px;
    margin: 20px 0;

    .goods-img {
      width: 136px;
      height: 136px;
      border: 2px solid #d9d9d9;
      border-radius: 20px;
      margin-right: 20px;
    }

    .goods-content {
      width: 70%;
      //display: flex;
      //flex-direction: column;
      //justify-content: space-between;
      //align-items: center;
      .goods-title {
        font-size: 30px;
        white-space: nowrap; /* 禁止换行 */
        overflow: hidden; /* 隐藏超出内容 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
      }

      .goods-text {
        font-size: 24px;
        color: #7884a8;
        white-space: nowrap; /* 禁止换行 */
        overflow: hidden; /* 隐藏超出内容 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
      }

      .goods-price {
        font-size: 22px;
        color: #003cbf;

        .price-blod {
          font-weight: bold;
          font-size: 34px;
        }
      }
    }
  }
}

::v-deep ul {
  display: block !important;
  list-style-position: inside !important;
  list-style:disc;
}

/* 内联问题选项样式 */
.question-options-inline {
  margin-top: 20px;
}

.option-item-inline {
  padding: 20px 25px;
  margin-bottom: 15px;
  border: 2px solid #e5e9f2;
  border-radius: 25px;
  font-size: 28px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  display: block;
  width: 100%;
  box-sizing: border-box;
}



.option-item-inline.selected {
  border-color: #0265FF;
  background: #f0f4ff;
  color: #0265FF;
}

.option-item-inline.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}

.confirm-btn-inline {
  background: #94BEFF;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 18px 60px;
  font-size: 30px;
  font-weight: bold;
  cursor: not-allowed;
  transition: all 0.3s ease;
  text-align: center;
  margin: 30px auto 0;
  width: 200px;
  display: block;
  pointer-events: none;
}

.confirm-btn-inline.enabled {
  background: #0265FF;
  cursor: pointer;
  pointer-events: auto;
}

.confirm-btn-inline.enabled:hover {
  background: #0056e6;
  transform: translateY(-2px);
}

.confirm-btn-inline.enabled:active {
  transform: translateY(0);
}
</style>
